import FileDownload from 'js-file-download';
import moment from 'moment';
import * as constants from "Constants";
import displayGlobalMessage from '../../../../../Utils/DisplayGlobalMessage';
// BEGIN-INTERNAL
import PushToRepoExp from '../../../../../Screens1/Instructor/Course/Content/Labs/Components/ActivityRow/PushToRepoExp';
// END-INTERNAL
import { AiOutlineCloudUpload } from 'react-icons/ai';
import httpService from 'services/httpService';
import log from "loglevel";

export const handleSort = (event, setSortField, setSortOrder, setQuerySortOrder) => {
  setSortField(event.sortField ? event.sortField : "");
  setSortOrder(event.sortOrder);
  if (event.sortOrder === -1) {
    setQuerySortOrder("-");
  } else {
    setQuerySortOrder("");
  }
};

export const PushToRepo = async (id) => {
  let form_data = new FormData();
  form_data.append("id", id);
  let url = `${constants.base_url}/evalpro/repository/${id}`;

  try {
    await httpService.post(url, form_data, {
      headers: {
        "content-type": "application/json",
      },
    });
    displayGlobalMessage(`Pushed to Repository`, "success");
  } catch (err) {
    displayGlobalMessage(`${err.response.data.detail[0]}`, "error");
  }
};

// BEGIN-INTERNAL
export const downloadAllSubmissions = async (activityType, activityId) => {
  if (activityType !== "virtual") {
    displayGlobalMessage(
      "This feature is available only for virtual activities",
      "error"
    );
    return;
  }
  let url = `${constants.base_url}/clab/activity/submission_files/?activity_id=${activityId}&all_users=true`;

  try {
    const response = await httpService.instance({
      url,
      method: "GET",
      responseType: "blob",
    });
    FileDownload(
      response.data,
      `Activity_${activityId}_submissions.tar.gz`
    );
    displayGlobalMessage("Submissions Downloaded Successfully!", "success");
  } catch (error) {
    log.error(error);
  }
};

export const downloadEvaluateResult = async (activityType, activityId) => {
  if (activityType !== "virtual") {
    displayGlobalMessage(
      "This feature is available only for virtual activities",
      "error"
    );
    return;
  }
  let url = `${constants.base_url}/clab/activity/${activityId}/evaluation_marks/`;
  try {
    const response = await httpService.instance({
      url,
      method: "GET",
      responseType: "blob",
    });

    if(response.status == 202) {
      displayGlobalMessage("Evaluation Results not available.", "error");
      return;
    }

    FileDownload(
      response.data,
      `cLab_activity_${activityId}_results.csv`
    );

    displayGlobalMessage("Evaluation Results Downloaded Successfully!", "success");
  } catch (error) {
      log.error(error);
      displayGlobalMessage("Error while downloading Evaluation Results!", "error");
  }
};

export const checkEvaluationStatus = async (activityType, activityId) => {
  if (activityType !== "virtual") {
    displayGlobalMessage(
      "This feature is available only for virtual activities",
      "error"
    );
    return;
  }
  let url = `${constants.base_url}/clab/activity/${activityId}/evaluation_status/`;
  try {
    const response = await httpService.get(url);
    if(response.data?.status) {
      const total = response.data.total;
      const evaluated = response.data.evaluated;
      displayGlobalMessage(`${evaluated} submission evaluted out of ${total}`, "success");
    } else {
      displayGlobalMessage("No Evaluation process going on!", "error");
    }
  } catch (error) {
    log.error(error);
    displayGlobalMessage("Error while checking Evaluation Status!", "error");
  }
};

export const evaluateClabSubmissions = async (activityType, activityId) => {
  if (activityType !== "virtual") {
    displayGlobalMessage(
      "This feature is available only for virtual activities",
      "error"
    );
    return;
  }
  let url = `${constants.base_url}/clab/activity/${activityId}/evaluate_all/`;
  try {
    const response = await httpService.post(
      url
    )
    displayGlobalMessage(response.data?.status, "success");
  } catch (error) {
    if(error.response?.headers?.status == 400) {
      displayGlobalMessage("Lab endtime not passed yet!", "error");
    } else {
      log.error(error);
      displayGlobalMessage("Error while starting Evaluation!", "error");
    }
  }
};
// END-INTERNAL

export const toggleActivityVisibility = async (activityId, activityType, status, setActivityVisibility, labId, setActivities) => {
  // Optimistically update UI immediately
  setActivityVisibility(prevState => ({
    ...prevState,
    [activityId]: status
  }));

  // Also update the activities array to keep it in sync
  if (setActivities) {
    setActivities(prevActivities =>
      prevActivities.map(activity =>
        activity.id === activityId
          ? { ...activity, is_published: status }
          : activity
      )
    );
  }

  try {
    let form_data = new FormData();
    form_data.append("is_published", status);

    if (activityType === "programming") {
      form_data.append("is_visibility_changed", true);
    }
    if (activityType === "other") {
      form_data.append("lab", labId);
    }

    let url = `${constants.base_url}/lab/activity/${activityId}?type=${activityType}`;

    if (activityType === "virtual") {
      url = `${constants.base_url}/clab/activity/${activityId}/publish/`;
      const response = await httpService.post(url, form_data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      log.log(response);
    } else {
      const response = await httpService.put(url, form_data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      log.log(response);
    }

    displayGlobalMessage("Activity has been updated Successfully!", "success");

  } catch (error) {
    // Revert the optimistic updates on error
    setActivityVisibility(prevState => ({
      ...prevState,
      [activityId]: !status
    }));

    if (setActivities) {
      setActivities(prevActivities =>
        prevActivities.map(activity =>
          activity.id === activityId
            ? { ...activity, is_published: !status }
            : activity
        )
      );
    }

    displayGlobalMessage("Error in adding Activity!", "error");
    log.error("Error toggling activity visibility:", error);
  }
};

export const handlepushtorepo = (id, data, lab_title, courseId, lab_Id) => {
  // BEGIN-INTERNAL
  if (data?.typeOfActivity === "virtual") {
    return (
      <PushToRepoExp
        id={id}
        lab_title={lab_title}
        course={courseId}
        lab_id={lab_Id}
      />
    );
  } else {
  // END-INTERNAL
    return (
      <AiOutlineCloudUpload size="30" onClick={(e) => PushToRepo(id)} />
    );
  // BEGIN-INTERNAL
  }
  // END-INTERNAL
};

export const ActivityExportHandler = async (activityId, activityType, activityTitle) => {
  let url = `${constants.base_url}/lab/activity/${activityId}?type=${activityType}&action=archive_program`;

  try {
    const response = await httpService.instance({
      url,
      method: "GET",
      responseType: "blob",
    });
    FileDownload(response.data, `${activityTitle}.zip`);
    displayGlobalMessage("Activity Exported Successfully!", "success");
  } catch (error) {
    log.error(error);
  }
};

export const moveToRecycleBin = async (activityId, activityType, activities, setActivities) => {
  if (activityType === "programming") {
    if (confirm("Are you sure want to move this Activity to the Recycle Bin?")) {
      let url = `${constants.base_url}/lab/activity/${activityId}?type=programming&action=move_trash`;

      try {
        await httpService.delete(url);
        setActivities(activities.filter(activity => activity.id !== activityId));
        displayGlobalMessage("Activity Moved to Recycle Bin Successfully", "success");
      } catch (error) {
        displayGlobalMessage(`${error}`, "error");
      }
    }
  } else if (confirm("Are you sure want to permanently delete this Activity?")) {
    let url = constants.base_url + "/clab/activity/" + activityId + "/";
      try {
        httpService.delete(url);
        // Filtering out the deleted activity by filter function on the array of list of activities maintained
        // in the activities state variable. This way, it will not reload the whole component and will be quick enough.
        setActivities(
          activities.filter(function (activity) {
            return activity.id !== activityId;
          })
        );
        displayGlobalMessage("Activity Moved to Recycle Bin Successfully", "success");
      } catch (error) {
        displayGlobalMessage(`${error}`, "error");
        log.error(error);
      }
  }
};

// BEGIN-INTERNAL
export const evaluate = async (activityId, activityType, isEvaluate, setEvaluate) => {
  if (activityType === "virtual") {
    const expId = activityId;
    if (!isEvaluate) {
      try {
        const response = await httpService.post(`/vlab/experiment/${expId}/evaluate/`);
        displayGlobalMessage(response.data.status, "success");
        setEvaluate(true);
      } catch {
        displayGlobalMessage("Error In Evaluation", "error");
      }
    } else {
      try {
        const response = await httpService.get(`/vlab/experiment/${expId}/evaluationStatus/`);
        if (response.data === "Evaluations Completed!") {
          displayGlobalMessage(response.data, "success");
          setEvaluate(false);
        } else {
          displayGlobalMessage(response.data, "error");
        }
      } catch {
        displayGlobalMessage("Error In Checking Status", "error");
      }
    }
  }
};
// END-INTERNAL

export const ActivityEvaluateHandler = async (activityId, availableTill, today) => {
  if (moment(availableTill).isAfter(moment(today))) {
    displayGlobalMessage("Evaluation can't be done before the Lab Deadline", "error");
  } else {
    let url = `${constants.base_url}/otherlabs/evaluate_lab/${activityId}`;
    try {
      await httpService.get(url);
      displayGlobalMessage("Lab evaluation completed", "success");
    } catch (error) {
      log.error(error);
    }
  }
};

export const ActivityResultHandler = async (activityId, availableTill, today) => {
  if (moment(availableTill).isAfter(moment(today))) {
    displayGlobalMessage("Results can't be downloaded without evaluation", "error");
  } else {
    let url = `${constants.base_url}/otherlabs/download/${activityId}/results`;
    try {
      const response = await httpService.instance({
        url,
        method: "GET",
        responseType: "blob",
      });
      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", "marks.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      log.error(error);
    }
  }
};